/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ConversationDeletedObject = {
  /**
   * The ID of the deleted conversation
   */
  id: string;
  object: "conversation.deleted";
  /**
   * Always true
   */
  deleted: boolean;
};

/** @internal */
export const ConversationDeletedObject$inboundSchema: z.ZodType<
  ConversationDeletedObject,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  object: z.literal("conversation.deleted"),
  deleted: z.boolean(),
});
/** @internal */
export type ConversationDeletedObject$Outbound = {
  id: string;
  object: "conversation.deleted";
  deleted: boolean;
};

/** @internal */
export const ConversationDeletedObject$outboundSchema: z.ZodType<
  ConversationDeletedObject$Outbound,
  z.ZodTypeDef,
  ConversationDeletedObject
> = z.object({
  id: z.string(),
  object: z.literal("conversation.deleted"),
  deleted: z.boolean(),
});

export function conversationDeletedObjectToJSON(
  conversationDeletedObject: ConversationDeletedObject,
): string {
  return JSON.stringify(
    ConversationDeletedObject$outboundSchema.parse(conversationDeletedObject),
  );
}
export function conversationDeletedObjectFromJSON(
  jsonString: string,
): SafeParseResult<ConversationDeletedObject, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ConversationDeletedObject$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ConversationDeletedObject' from JSON`,
  );
}
